<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">Diversion Books</span><br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1004<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Copyright © 1994 by </span><span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Theresa DiBenedetto</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</span></p>
<p class="double" style="text-align: center;">
	This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a>.</span></p>
<p style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">First Diversion Books edition October 2013</span><br/>
	ISBN: <span style="font-size: 1em; line-height: 1.375; font-family: 'Liberation Serif', serif; text-align: justify;">978-1-62681-156-0</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h1>
	Also by Raine Cantrell</h1>
<p class="sectiontop" style="text-align: center;">
	The Homecoming<br/>
	Wildflower<br/>
	Silver Mist<br/>
	Western Winds<br/>
	Desert Sunrise<br/>
	Calico<br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">Darling Annie</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">Whisper My Name</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p class="sectiontop" style="text-align: center;">
<em style="font-size: 1em; line-height: 1.5; text-indent: 1.5em; text-align: justify;">In loving memory of my father,</em><br/>
<em style="font-size: 1em; line-height: 1.5; text-indent: 1.5em; text-align: justify;">who shared his love of history</em><br/>
<em style="font-size: 1em; line-height: 1.5; text-indent: 1.5em; text-align: justify;">and books with me and was so proud</em><br/>
<em style="font-size: 1em; line-height: 1.5; text-indent: 1.5em; text-align: justify;">that I had become a writer</em><span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em; text-align: justify;">.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-copyright.vue?1b8c1830